<template>
    <v-alert
        :type="type"
        :color="type === 'success' ? 'primary' : ''"
        dense
    >
        <ul
            class="Alert__list"
            v-if="contentList"
        >
            <li
                v-for="(error, id) in contentList"
                :key="id"
            >
                {{ error[0] }}
            </li>
        </ul>

        <div v-if="contentString">
            {{ contentString }}
        </div>
    </v-alert>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            required: true
        },

        contentString: {
            type: String,
        },

        contentList: {
            type: Array,
        }
    },

    data() {
        return {};
    },

    mounted() {
    },

    methods: {}
};
</script>
<style lang="scss">
.Alert__list {
    list-style: none !important;
    margin: 0 0 12px !important;
    padding: 0 !important;
}
</style>
